/**
 * CUSTOM PRODUCT VIDEO - Re:Voir
 * Gestion de l'overlay vidéo pour les bandes-annonces
 */

(function() {
  'use strict';

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
  } else {
    initVideoControls();
  }

  function initVideoControls() {
    // Gérer tous les boutons de bande-annonce
    const trailerButtons = document.querySelectorAll('[data-video-url]');
    
    trailerButtons.forEach(button => {
      button.addEventListener('click', openVideoOverlay);
    });

    // Gérer tous les boutons de fermeture
    const closeButtons = document.querySelectorAll('[data-close-video]');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', closeVideoOverlay);
    });

    // Gérer les clics sur l'overlay (fermer si clic en dehors de la vidéo)
    const overlays = document.querySelectorAll('[data-video-overlay]');
    
    overlays.forEach(overlay => {
      overlay.addEventListener('click', function(e) {
        if (e.target === this) {
          closeVideoOverlay.call(this);
        }
      });
    });

    // Fermer avec la touche Échap
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const activeOverlay = document.querySelector('.custom-video-overlay.active');
        if (activeOverlay) {
          closeVideoOverlay.call(activeOverlay);
        }
      }
    });
  }

  function openVideoOverlay(e) {
    const button = e.currentTarget;
    const videoUrl = button.getAttribute('data-video-url');
    const productId = button.getAttribute('data-product-id');
    
    if (!videoUrl || !productId) return;

    const overlay = document.getElementById(`video-overlay-${productId}`);
    if (!overlay) return;

    const iframe = overlay.querySelector('[data-video-iframe]');
    if (!iframe) return;

    // Charger la vidéo
    iframe.src = videoUrl;
    
    // Afficher l'overlay avec animation
    overlay.style.display = 'flex';
    
    // Petite astuce : forcer un reflow pour que la transition fonctionne
    overlay.offsetHeight;
    
    overlay.classList.add('active');
    
    // Empêcher le scroll du body
    document.body.style.overflow = 'hidden';
  }

  function closeVideoOverlay(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Trouver l'overlay (soit depuis le bouton, soit depuis l'élément lui-même)
    const overlay = this.closest ? this.closest('.custom-video-overlay') : this;
    
    if (!overlay || !overlay.classList.contains('custom-video-overlay')) return;

    const iframe = overlay.querySelector('[data-video-iframe]');
    
    // Retirer la classe active (animation de fade out)
    overlay.classList.remove('active');
    
    // Réactiver le scroll
    document.body.style.overflow = '';
    
    // Attendre la fin de l'animation avant de cacher et de vider l'iframe
    setTimeout(() => {
      overlay.style.display = 'none';
      if (iframe) {
        iframe.src = '';
      }
    }, 300); // Correspond à la durée de la transition CSS
  }

  // Réinitialiser si Shopify recharge une section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initVideoControls);
  }
})();